// extracted by mini-css-extract-plugin
export default {"answer":"Y_-z","bestAnswerHeading":"Z_-z","meta":"__-z"};